// ─────────────────────────────────────────────────────────────────────────────
// 🔑 ONE SMALL HOOK FOR A HELD UPLOAD (2026-11-04 — constants/uploadChecking). After a 202 UPLOAD_CHECKING the screen
// calls hold(): it re-reads (refresh) every few seconds so the file appears once the quarantine sweep stores it, the
// caller keeps its upload control off while `held`, and `line` is the approved checking line (null while the wording is
// off — then the row simply stays "not uploaded yet"). It lets go after three minutes (the row shows what is true then).
// ⚠️ A follow-up the screen chains on the new document (attach to a property, a letter, a cheque month, an asset source)
// cannot run without the documentId the held answer lacks: the caller stops there and says nothing false.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from 'react';
import { UPLOAD_CHECKING_APPROVED, UPLOAD_CHECKING_COPY } from '../constants/uploadChecking';

export default function useHeldUpload(refresh, { everyMs = 5000, forMs = 3 * 60 * 1000 } = {}) {
  const [held, setHeld] = useState(false);
  useEffect(() => {
    if (!held) return undefined;
    const t = setInterval(() => { try { if (refresh) refresh(); } catch (_) { /* next tick */ } }, everyMs);
    const stop = setTimeout(() => setHeld(false), forMs);
    return () => { clearInterval(t); clearTimeout(stop); };
  }, [held]); // eslint-disable-line react-hooks/exhaustive-deps
  return { held, hold: () => setHeld(true), release: () => setHeld(false), line: held && UPLOAD_CHECKING_APPROVED ? UPLOAD_CHECKING_COPY : null };
}
